<form [formGroup]="sellerDetailsFormGroup" id="step-seller-details" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-0 overflow-visible">
    <div class="row">
      <div class="field-wr flex flex-col col-12 mt-2">
        <div class="row">
          <div class="col-12">
            <h3 data-testid="seller-details" class="border-b pb-3">{{ 'SALE_CREATE.SELLER_DETAILS' | translate }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="block text-sm">{{ 'SALE_CREATE.SELLER_TYPE' | translate }}</label>
            <div class="flex flex-wrap gap-4">
              @if (canUseMyselfSeller) {
                <label data-testid="sellertype-myself-label" class="inline-flex mr-6">
                  <p-radioButton data-testid="sellertype-myself" name="sellerType" value="myself" formControlName="sellerType" inputId="seller-type-myself"
                    (onClick)="onSellerTypeChange($event)"/>
                  <span for="seller-type-myself" class="ml-2">{{ 'SALE_CREATE.OPTION_SYSTEM_MYSELF' | translate }}</span>
                </label>
              }
              <label data-testid="sellertype-system-label" class="inline-flex mr-6">
                <p-radioButton data-testid="sellertype-system" name="sellerType" value="system" formControlName="sellerType" inputId="seller-type-system"
                  (onClick)="onSellerTypeChange($event)"/>
                <span for="seller-type-system" class="ml-2">{{ 'SALE_CREATE.OPTION_SYSTEM_SELLER' | translate }}</span>
              </label>
              @if (hasUnregisteredUserFeature) {
                <label data-testid="sellertype-guest-label" class="inline-flex mr-2">
                  <p-radioButton data-testid="sellertype-guest" name="sellerType" value="guest" formControlName="sellerType" inputId="seller-type-guest"
                    (onClick)="onSellerTypeChange($event)"/>
                  <span for="seller-type-guest" class="ml-2">{{ 'SALE_CREATE.OPTION_GUEST_SELLER' | translate }}</span>
                </label>
              }
            </div>
          </div>
          @if (sellerDetailsFormGroup.get('sellerType')?.value === 'guest') {
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
              <div class="flex flex-row items-center gap-2 mt-auto">
                <p-checkbox data-testid="create-guest-input" formControlName="createGuestUser" inputId="createGuestUser" binary="true" (onChange)="onCreateGuestUserChange($event)" />
                <label for="createGuestUser">{{ 'SALE_CREATE.CREATE_GUEST_SELLER' | translate }}</label>
              </div>
            </div>
          }
        </div>

        @if (sellerDetailsFormGroup.get('sellerType')?.value === 'myself') {
          <div class="row">
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
              <label data-testid="myself-retailer-label" class="block text-sm" for="myselfRetailerId">
                {{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i>
              </label>
              <app-custom-dropdown
                data-testid="myself-retailer"
                [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="false"
                [showSelectionChips]="true"
                [showClear]="true"
                [searchMode]="'remote'"
                [pageSize]="combosData['myselfRetailers'].rowsPerPageOption || 5"
                [totalCount]="combosData['myselfRetailers'].totalRecords"
                [totalPages]="getComboTotalPages('myselfRetailers')"
                [options]="combosData['myselfRetailers'].list"
                formControlName="myselfRetailerId"
                (onLazyLoad)="onLazyLoadComboData('myselfRetailers', $event)">
              </app-custom-dropdown>
              @if (combosData['myselfRetailers'].totalRecords === 0) {
                <small data-testid="myself-retailer-error" class="p-error">{{ 'SALE_CREATE.USER_HAS_NO_RETAILERS_ASSIGNED' | translate }}</small>
              } @else {
                @if (sellerDetailsFormGroup.get('myselfRetailerId')?.invalid && sellerDetailsFormGroup.get('myselfRetailerId')?.touched) {
                  <small data-testid="myself-retailer-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                }
              }
            </div>
            @if(showDistributionChannel){
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !sellerDetailsFormGroup.get('myselfRetailerId')?.value?.length }">
                <label data-testid="myself-distributionchannel-label" class="block text-sm" for="myselfDistributionChannelId">
                  {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i>
                </label>
                <app-custom-dropdown
                  data-testid="myself-distributionChannel"
                  [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                  optionLabel="text"
                  optionValue="id"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showClear]="true"
                  [searchMode]="'remote'"
                  [pageSize]="combosData['myselfDistributionChannels'].rowsPerPageOption || 5"
                  [totalCount]="combosData['myselfDistributionChannels'].totalRecords"
                  [totalPages]="getComboTotalPages('myselfDistributionChannels')"
                  [options]="combosData['myselfDistributionChannels'].list"
                  formControlName="myselfDistributionChannelId"
                  (onLazyLoad)="onLazyLoadComboData('myselfDistributionChannels', $event)">
                </app-custom-dropdown>
                @if (sellerDetailsFormGroup.get('myselfDistributionChannelId')?.invalid && sellerDetailsFormGroup.get('myselfDistributionChannelId')?.touched) {
                  <small data-testid="myself-distributionChannel-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                }
              </div>
             }
          </div>
        }
        @if (sellerDetailsFormGroup.get('sellerType')?.value === 'system') {
          <div class="row">
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
              <label data-testid="user-label" class="block text-sm" for="systemUserId">
                {{ 'SALE_CREATE.SYSTEM_SELLER' | translate }} <i class="icon-required-field"></i>
              </label>
              <app-custom-dropdown
                data-testid="system-user"
                [placeholder]="'SALE_CREATE.SELECT_SYSTEM_SELLER' | translate"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="false"
                [showSelectionChips]="true"
                [showClear]="true"
                [searchMode]="'remote'"
                [pageSize]="combosData['systemUsers'].rowsPerPageOption || 5"
                [totalCount]="combosData['systemUsers'].totalRecords"
                [totalPages]="getComboTotalPages('systemUsers')"
                [options]="combosData['systemUsers'].list"
                formControlName="systemUserId"
                (onLazyLoad)="onLazyLoadComboData('systemUsers', $event)">
              </app-custom-dropdown>
              @if (sellerDetailsFormGroup.get('systemUserId')?.invalid && sellerDetailsFormGroup.get('systemUserId')?.touched) {
                <small data-testid="system-user-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
              }
            </div>
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !sellerDetailsFormGroup.get('systemUserId')?.value?.length }">
              <label data-testid="retailer-label" class="block text-sm" for="systemRetailerId">
                {{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i>
              </label>
              <app-custom-dropdown
                data-testid="system-retailer"
                [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="false"
                [showSelectionChips]="true"
                [showClear]="true"
                [searchMode]="'remote'"
                [pageSize]="combosData['systemRetailers'].rowsPerPageOption || 5"
                [totalCount]="combosData['systemRetailers'].totalRecords"
                [totalPages]="getComboTotalPages('systemRetailers')"
                [options]="combosData['systemRetailers'].list"
                formControlName="systemRetailerId"
                (onLazyLoad)="onLazyLoadComboData('systemRetailers', $event)">
              </app-custom-dropdown>
              @if (showErrorSystemNoRetailersAssigned) {
                <small data-testid="system-retailer-error" class="p-error">{{ 'SALE_CREATE.USER_HAS_NO_RETAILERS_ASSIGNED' | translate }}</small>
              }
              @if (!showErrorSystemNoRetailersAssigned && sellerDetailsFormGroup.get('systemRetailerId')?.invalid && sellerDetailsFormGroup.get('systemRetailerId')?.touched) {
                <small data-testid="system-retailer-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
              }
            </div>
            @if(showDistributionChannel){
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !sellerDetailsFormGroup.get('systemRetailerId')?.value?.length }">
              <label data-testid="distributionchannel-label" class="block text-sm" for="systemDistributionChannelId">
                {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i>
              </label>
              <app-custom-dropdown
                data-testid="system-distributionChannel"
                [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="false"
                [showSelectionChips]="true"
                [showClear]="true"
                [searchMode]="'remote'"
                [pageSize]="combosData['systemDistributionChannels'].rowsPerPageOption || 5"
                [totalCount]="combosData['systemDistributionChannels'].totalRecords"
                [totalPages]="getComboTotalPages('systemDistributionChannels')"
                [options]="combosData['systemDistributionChannels'].list"
                formControlName="systemDistributionChannelId"
                (onLazyLoad)="onLazyLoadComboData('systemDistributionChannels', $event)">
              </app-custom-dropdown>
              @if (!showErrorSystemNoRetailersAssigned && sellerDetailsFormGroup.get('systemDistributionChannelId')?.invalid && sellerDetailsFormGroup.get('systemDistributionChannelId')?.touched) {
                <small data-testid="system-distributionChannel-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
              }
            </div>
            }
          </div>
        }
        @if (sellerDetailsFormGroup.get('sellerType')?.value === 'guest') {
          <div class="row">
            @if (sellerDetailsFormGroup.get('createGuestUser')?.value === false) {
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
                <label data-testid="user-label" class="block text-sm" for="guestUserId">
                  {{ 'SALE_CREATE.GUEST_SELLER' | translate }} <i class="icon-required-field"></i>
                </label>
                <app-custom-dropdown
                  data-testid="guest-user"
                  [placeholder]="'SALE_CREATE.SELECT_GUEST_SELLER' | translate"
                  optionLabel="text"
                  optionValue="id"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showClear]="true"
                  [searchMode]="'remote'"
                  [pageSize]="combosData['guestUsers'].rowsPerPageOption || 5"
                  [totalCount]="combosData['guestUsers'].totalRecords"
                  [totalPages]="getComboTotalPages('guestUsers')"
                  [options]="combosData['guestUsers'].list"
                  formControlName="guestUserId"
                  (onLazyLoad)="onLazyLoadComboData('guestUsers', $event)">
                </app-custom-dropdown>
                @if (sellerDetailsFormGroup.get('guestUserId')?.invalid && sellerDetailsFormGroup.get('guestUserId')?.touched) {
                  <small data-testid="guest-user-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !sellerDetailsFormGroup.get('guestUserId')?.value?.length }">
                <label data-testid="retailer-label" class="block text-sm" for="guestRetailerId">
                  {{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i>
                </label>
                <app-custom-dropdown
                  data-testid="guest-retailer"
                  [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                  optionLabel="text"
                  optionValue="id"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showClear]="true"
                  [searchMode]="'remote'"
                  [pageSize]="combosData['guestRetailers'].rowsPerPageOption || 5"
                  [totalCount]="combosData['guestRetailers'].totalRecords"
                  [totalPages]="getComboTotalPages('guestRetailers')"
                  [options]="combosData['guestRetailers'].list"
                  formControlName="guestRetailerId"
                  (onLazyLoad)="onLazyLoadComboData('guestRetailers', $event)">
                </app-custom-dropdown>
                @if (showErrorGuestNoRetailersAssigned) {
                  <small data-testid="guest-retailer-error" class="p-error">{{ 'SALE_CREATE.USER_HAS_NO_RETAILERS_ASSIGNED' | translate }}</small>
                }
                @if (!showErrorGuestNoRetailersAssigned && sellerDetailsFormGroup.get('guestRetailerId')?.invalid && sellerDetailsFormGroup.get('guestRetailerId')?.touched) {
                  <small data-testid="guest-retailer-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                }
              </div>
              @if(showDistributionChannel){
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !sellerDetailsFormGroup.get('guestRetailerId')?.value?.length }">
                  <label data-testid="distributionchannel-label" class="block text-sm" for="guestDistributionChannelId">
                    {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i>
                  </label>
                  <app-custom-dropdown data-testid="guest-distributionChannel"
                    [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['guestDistributionChannels'].rowsPerPageOption || 5"
                    [totalCount]="combosData['guestDistributionChannels'].totalRecords"
                    [totalPages]="getComboTotalPages('guestDistributionChannels')"
                    [options]="combosData['guestDistributionChannels'].list"
                    formControlName="guestDistributionChannelId"
                    (onLazyLoad)="onLazyLoadComboData('guestDistributionChannels', $event)">
                  </app-custom-dropdown>
                  @if (!showErrorGuestNoRetailersAssigned && sellerDetailsFormGroup.get('guestDistributionChannelId')?.invalid && sellerDetailsFormGroup.get('guestDistributionChannelId')?.touched) {
                    <small data-testid="guest-distributionChannel-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              }
            }
            @if (sellerDetailsFormGroup.get('createGuestUser')?.value === true) {
              <div class="row mt-3">
                <div class="col-12">
                  <h3 data-testid="add-guest-details" class="border-b pb-3">{{ 'SALE_CREATE.NEW_GUEST_SELLER_DETAILS' | translate }}</h3>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  <label data-testid="add-guest-field-firstname" class="block text-sm" for="firstname">{{ 'CREATE_GUEST_SELLER.FIRST_NAME' | translate }} <i
                  class="icon-required-field"></i></label>
                  <input data-testid="add-guest-firstname-input" type="text" formControlName="firstname" autocomplete="off">
                  @if (sellerDetailsFormGroup.get('firstname')?.invalid && sellerDetailsFormGroup.get('firstname')?.touched) {
                    <small data-testid="add-guest-firstname-mandatory"  class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  <label data-testid="add-guest-field-firstnameromanised" class="block text-sm" for="romanisedFirstName">{{ 'CREATE_GUEST_SELLER.ROMANIZED_FIRST_NAME' | translate }}</label>
                  <input data-testid="add-guest-firstnameromanised-input" type="text" formControlName="romanisedFirstName" autocomplete="off">
                  @if (sellerDetailsFormGroup.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                    <small data-testid="add-guest-romanisedfirstname-error" class="p-error">
                      {{ 'CREATE_GUEST_SELLER.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                    </small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  <label data-testid="add-guest-field-lastname" class="block text-sm" for="lastname">{{ 'CREATE_GUEST_SELLER.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-guest-lastname-input" type="text" formControlName="lastname" autocomplete="off">
                  @if (sellerDetailsFormGroup.get('lastname')?.invalid && sellerDetailsFormGroup.get('lastname')?.touched) {
                    <small data-testid="add-guest-lastname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  <label data-testid="add-guest-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{ 'CREATE_GUEST_SELLER.ROMANIZED_LAST_NAME' | translate }}</label>
                  <input data-testid="add-guest-romanisedlastname-input" type="text" formControlName="romanisedLastName" autocomplete="off">
                  @if (sellerDetailsFormGroup.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                    <small data-testid="add-guest-romanisedlastname-error" class="p-error">
                      {{ 'CREATE_GUEST_SELLER.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                    </small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <label data-testid="add-guest-field-assigned-retailers" class="block text-sm" for="retailer">{{ 'SALE_CREATE.ASSIGN_RETAILERS' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="guest-retailer"
                    [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                    [fieldLabel]="'SALE_CREATE.ASSIGN_RETAILERS' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['createGuestRetailers'].rowsPerPageOption || 5"
                    [totalCount]="combosData['createGuestRetailers'].totalRecords"
                    [totalPages]="getComboTotalPages('createGuestRetailers')"
                    [options]="combosData['createGuestRetailers'].list"
                    formControlName="createGuestRetailerId"
                    (onLazyLoad)="onLazyLoadComboData('createGuestRetailers', $event)">
                  </app-custom-dropdown>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" id="pos-new-guest-seller"
                  [ngClass]="{'disabled': !sellerDetailsFormGroup.get('createGuestRetailerId')?.value?.length}">
                  <label data-testid="add-guest-field-retailer" class="block text-sm" for="retailer">{{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="guest-retailer"
                    [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'local'"
                    [pageSize]="combosData['guestRetailers'].rowsPerPageOption || 5"
                    [options]="combosData['guestRetailers'].list"
                    formControlName="guestRetailerId">
                  </app-custom-dropdown>
                </div>
                @if(showDistributionChannel){
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
                  [ngClass]="{ 'disabled': !sellerDetailsFormGroup.get('guestRetailerId')?.value?.length }">
                  <label data-testid="add-guest-field-distributionchannel" class="block text-sm" for="distributionChannel">
                    {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }}
                    <i class="icon-required-field"></i>
                  </label>
                  <app-custom-dropdown
                    data-testid="guest-distributionChannel"
                    [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['guestDistributionChannels'].rowsPerPageOption || 5"
                    [totalCount]="combosData['guestDistributionChannels'].totalRecords"
                    [totalPages]="getComboTotalPages('guestDistributionChannels')"
                    [options]="combosData['guestDistributionChannels'].list"
                    formControlName="guestDistributionChannelId"
                    (onLazyLoad)="onLazyLoadComboData('guestDistributionChannels', $event)">
                  </app-custom-dropdown>
                  @if (!showErrorGuestNoRetailersAssigned && sellerDetailsFormGroup.get('guestDistributionChannelId')?.invalid && sellerDetailsFormGroup.get('guestDistributionChannelId')?.touched) {
                    <small data-testid="guest-distributionChannel-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                }
              </div>
            }
          </div>
        }

        @if (sellerDetailsFormGroup.get('sellerType')?.value === 'guest' && sellerDetailsFormGroup.get('createGuestSeller')?.value === true) {
        }

        <div class="row mt-3">
          <div class="field-wr flex flex-col col-12 col-md-2 mt-auto">
            <button data-testid="add-seller-btn" class="btn primary-btn" [disabled]="sellerDetailsFormGroup.invalid"
            (click)="onSaveStepData()">{{ 'SALE_CREATE.BTN_NEXT_STEP' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
